export interface ITAX_SAVING_FORMULA {
  currIncome: number;
  currInvestment: number;
}
export const TAX_SAVING_FORMULA = ({
  currIncome,
  currInvestment,
}: ITAX_SAVING_FORMULA) => {
  const currInc = Number(currIncome);
  const currInvest = Number(currInvestment);
  const balance = 150000 - currInvest;
  if (currInc < 0 || currInc > 1e10 || currInvest < 0 || currInvest > 15e4) {
    const emptyRes = 0;
    const emptymsg = '';
    return {
      taxableIncome: emptyRes,
      message: emptymsg,
    };
  }
  let taxSaveInvest = 0;
  if (currInc > 1000000) taxSaveInvest = (balance * 30) / 100;
  else if (currInc > 500000) taxSaveInvest = (balance * 20) / 100;
  else if (currInc > 250000) taxSaveInvest = (balance * 5) / 100;
  else taxSaveInvest = 0;
  taxSaveInvest = Math.round(taxSaveInvest);
  const returnOnELSS = Math.round((balance * 22.5) / 100);
  const totalsave = Math.round(taxSaveInvest + returnOnELSS);
  let msg = '';
  if (currInc < 250000)
    msg +=
      "Great! You have to pay No taxes this FY 23-24. But you don't to have to invest just to save taxes. Invest in Growth Mutual Funds for higher returns than FD/PPF. You can start with as low as ₹3000. Invest Now";
  else if (currInc > 250000 && currInvest >= 150000)
    msg +=
      'Great! You have made smart investments this year for saving taxes. Are you making the best use of your salary? Start making monthly Investments with as low as ₹2000 in growth mutual funds via SIP. Invest in Growth Funds';
  if (currInc > 250000 && balance > 1)
    msg += `You could have saved ₹${totalsave}. You lost ₹${taxSaveInvest} by not investing in Section 80C. Invest in Tax Saving Funds. You also lost an option of making additional ₹${returnOnELSS} by not investing in Tax Saving Funds. In 2024, our customers made 22.5%* returns on average by investing in tax-saving mutual funds on the ClearTax Invest platform.`;
  return {
    taxableIncome: currInc,
    message: msg,
  };
};
